import { Typography, makeStyles } from '@material-ui/core';
import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { SGSFormDate } from 'components';
import SGSInputCurrency from 'components/SGSCurrency';
import { SalaryBaseS3201 } from '.';

type TableSalaireProps = {
    salaries: SalaryBaseS3201[];
};

export const TableSalaryBase: React.FC<TableSalaireProps> = ({ salaries }) => {
    const classes = useStyles();

    return (
        <StyledTableContainer>
            <Table>
                <TableHead>
                    <StyledTableRow>
                        <StyledTableCellHeader colSpan={2} align="center">
                            <Typography>SALAIRE DE BASE</Typography>
                        </StyledTableCellHeader>
                        <StyledTableCellHeader> </StyledTableCellHeader>
                    </StyledTableRow>
                    <TableRow className={classes.tableHeader}>
                        <StyledTableHeaderCell>
                            <Box>
                                <Typography className={classes.txtGreen}>PERIODE DE REFERENCE</Typography>
                                <Box display="flex">
                                    <Box flex="1" display="flex" justifyContent="center">
                                        <Typography className={classes.txtGreen}>Du</Typography>
                                    </Box>
                                    <Box flex="1" display="flex" justifyContent="center">
                                        <Typography className={classes.txtGreen}>Au</Typography>
                                    </Box>
                                </Box>
                            </Box>
                        </StyledTableHeaderCell>
                        <StyledTableHeaderCell>
                            <Typography className={classes.txtGreen}>Montant du salaire</Typography>
                        </StyledTableHeaderCell>
                        <StyledTableHeaderCell></StyledTableHeaderCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {salaries.map((item, index) => (
                        <TableRow className="detail" key={item.id}>
                            <StyledTableCell>
                                <Box>
                                    <Box display="flex">
                                        <Box width="50%" style={{ marginRight: '15px' }}>
                                            <SGSFormDate inputVariant="outlined" name={`salaryBaseS3201.${index}.startDate`} disabled />
                                        </Box>
                                        <Box width="50%">
                                            <SGSFormDate inputVariant="outlined" name={`salaryBaseS3201.${index}.endDate`} disabled />
                                        </Box>
                                    </Box>
                                </Box>
                            </StyledTableCell>
                            <StyledTableCell>
                                <SGSInputCurrency name={`salaryBaseS3201.${index}.amount`} />
                            </StyledTableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </StyledTableContainer>
    );
};

const useStyles = makeStyles(() => ({
    header: {
        height: '54px',
    },
    dtEmis: {
        color: '#fff',
        fontSize: '0.8rem',
        fontFamily: 'Open Sans',
        fontStyle: 'normal',
        height: '100%',
        width: '170px',
    },

    txtGreen: {
        color: '#2574A9',
        fontSize: '0.93rem ',
        fontFamily: 'Open Sans ',
        fontStyle: 'normal ',
        fontWeight: 700,
    },

    tableHeader: {},
}));

const StyledTableContainer = styled(TableContainer)(() => ({
    boxShadow: 'none',
    //border: '1px solid #3ba7ca',
    borderTop: 'none',
}));

const StyledTableRow = styled(TableRow)(() => ({
    borderBottom: 'none',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
}));

const StyledTableCellHeader = styled(TableCell)(() => ({
    backgroundColor: '#3399DB',
    color: '#FFF',
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    paddingTop: '5px',
    height: '54px',
    paddingBottom: '3px',
    border: '1px solid #3399DB',
    '&:last-child': {
        background: 'none',
        border: 'none',
    },
}));

const StyledTableHeaderCell = styled(TableCell)(() => ({
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    borderLeft: '1px solid #cdcdcd',
    borderRight: '1px solid #cdcdcd',
    borderBottom: '1px solid #cdcdcd',
    borderTop: 'none',
    background: '#F5F5F5',
    '&:last-child': {
        background: 'none',
        border: 'none',
    },
}));

const StyledTableCell = styled(TableCell)(() => ({
    fontFamily: 'Open Sans',
    fontStyle: 'normal',
    fontSize: '0.85rem',
    textAlign: 'center',
    verticalAlign: 'top',
    borderLeft: '1px solid #cdcdcd',
    borderRight: '1px solid #cdcdcd',
    borderBottom: '1px solid #cdcdcd',
    borderTop: 'none',
    background: '#FFF',
}));
